import Model from "./base/model";

class TakerAdditionalData extends Model{
  resourceName() {
    return "taker_additional_data";
  }

  fields() {
    return {
      additional_data: "",
      contributors: "",
      website: "",
      extra_address: "",
      address: {jsonApi: "hasOne", type: "addresses"},
    };
  }

}

export default new TakerAdditionalData();
